module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ykg8Tk/tc-custom/9781526781666.jpg?1706644534286",
      "alt": "This image is the cover for the book Battles on the Tigris"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Battles on the Tigris\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In 1914 the British expedition to Mesopotamia set out with the modest ambition of protecting the oil concession in Southern Persia but, after numerous misfortunes, ended up capturing Baghdad and Northern Towns in Iraq.  Initially the mission was successful in seizing Basra but the British under Generals Nixon and Townshend, found themselves drawn North, becoming besieged by the Turks at Kut. After various failed relief attempts the British surrendered and the prisoners suffered appalling indignities and hardship, culminating in a death march to Turkey.  In 1917 General Maude was appointed CinC but, as usual in Iraq, policy kept changing. Hopes that the Russians would come into the war were dashed by the Revolution. Operations were further frustrated by the hottest of summers. Fighting against the Turks continued right up to the Armistice. The conduct of the Campaign was subject to a Commission of Inquiry which was highly critical of numerous individuals and the administrative arrangements.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ron Wilcox\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen & Sword Military\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0